<script setup lang="ts">
import useStore from "@src/stores/store";
import AccordionButton from "@src/components/ui/data-display/AccordionButton.vue";
import Collapse from "@src/components/ui/utils/Collapse.vue";
import SettingsSwitch from "@src/components/views/HomeView/Sidebar/Settings/SettingsAccordion/SettingsSwitch.vue";



const props = defineProps<{
    collapsed: boolean;
    handleToggle: () => void;
}>();

const store = useStore();
</script>

<template>
    <AccordionButton
        id="appearance-settings-toggler"
        class="w-full flex px-5 py-6 mb-3 rounded focus:outline-none"
        :collapsed="props.collapsed"
        chevron
        aria-controls="appearance-settings-collapse"
        @click="props.handleToggle()"
    >
        <p class="heading-2 text-black/70 dark:text-white/70 mb-1">Aparência</p>
        <p class="body-2 text-black/70 dark:text-white/70">
            Customize o visual do sistema
        </p>
    </AccordionButton>

    <Collapse id="appearance-settings-collapse" :collapsed="props.collapsed">
        <div class="px-5">
            <SettingsSwitch
                title="Modo Escuro"
                description="Aplicar tema com cores escuras"
                :value="!!store.settings.darkMode"
                :handle-toggle-switch="(value: boolean) => (store.settings.darkMode = value)"
                class="mb-7"
            />

<!--            <SettingsSwitch-->
<!--                title="Tema com bordas"-->
<!--                description="Aplicar bordas na interface"-->
<!--                :value="!!store.settings.borderedTheme"-->
<!--                :handle-toggle-switch="(value: boolean) => (store.settings.borderedTheme = value)"-->
<!--                class="mb-2"-->
<!--            />-->
        </div>
    </Collapse>
</template>
